// define
// 本番環境
if ("myrate.jp" === document.domain) {
    // FIREBASE
    Object.defineProperty(exports, "FIREBASE_CONFIG", {
        value:          {
                            apiKey: "AIzaSyBiOK8k5AscSLvRMNkZPRS61WUcuyDRWnA",
                            authDomain: "n-license-pro.firebaseapp.com",
                            databaseURL: "https://n-license-pro.firebaseio.com",
                            projectId: "n-license-pro",
                            storageBucket: "n-license-pro.appspot.com",
                            messagingSenderId: "152097958886"
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });

    // TRUST DOCK
    Object.defineProperty(exports, "TRUSTDOCK_CONFIG", {
        value:          {
                            documents_api_url: 'https://api.trustdock.io/v1/documents/',
                            documents_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Project-Key':'DW2ExoaMkrSWkMRMyKHJsbtJ',
                                'HOST':'api.trustdock.io'
                            },
                            review_api_url: 'https://api.trustdock.io/v1/review/',
                            review_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer tksEHm9dCg6bBX8defqcwK4r',
                                'HOST':'api.trustdock.io'
                            },
                            delete_api_url: 'https://api.trustdock.io/v1/review/',
                            delete_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer tksEHm9dCg6bBX8defqcwK4r',
                                'HOST':'api.trustdock.io'
                            },
                            update_api_url: 'https://api.trustdock.io/v1/review/',
                            update_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer tksEHm9dCg6bBX8defqcwK4r',
                                'HOST':'api.trustdock.io'
                            },
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });

    // Scorer Server
    Object.defineProperty(exports, "SCORER_SERVER", {
        value:          {
                            pem:'-----BEGIN PUBLIC KEY-----\n'+
'MIIBHjANBgkqhkiG9w0BAQEFAAOCAQsAMIIBBgKB/gC2BbQdwQ/yCg4PDKLUFq/2\n'+
'hEU9TuUgghC7QixKY1CXrItGF2xmWxZ43zT/RVj2GK8HPd9kEebOZz7QhvCLOk58\n'+
'nEZlNcsviDeM/kbdd5twji+NxMjNYB2jd3tE6EI+0TJnaxEcezar4HohTLDNta0W\n'+
'fttk8l9ySPEzuhxd6QFwRLkQvzjMPcQmrXuZp4DSIeaG4fF2WxL5Bjgh9XBZX7yn\n'+
'zOk5r3LmFa8zmpbXpnT7qoD6lk8syy05K+l4mei3tURM5XXdJGztdbgqJj0+Hkhy\n'+
'wZVJ/fgi+wVZpxvKDISe7fDk3w+YKBWVjou5k8ekpWuya1DOufjP7GBJIdFlAgMB\n'+
'AAE=\n'+
'-----END PUBLIC KEY-----',
                            url:'https://myrate-scraper.com'
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });


    // Auth0
    Object.defineProperty(exports, "AUTH0_CONFIG", {
        value:          { 
                          domain: 'n-village.auth0.com', 
                          clientID: 'O2UnRvJRXSOUq6I0rKG65zc78PW3ytt2', 
                          redirectUri: 'https://myrate.jp/newflow5', 
                          responseType: "code"
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });
    
    Object.defineProperty(exports, "ENV", {
        value: {
            passwordSecret: 'Srt9xjbWr5pK'
        },
        enumerable: true,
        writable: false,
        configurable: false,
    })
    // reCAPTCHA
    Object.defineProperty(exports, "RECAPTCHA_CONFIG", {
        value: {
            siteKey: '6Le5y5sUAAAAADTbqGFfB4Jdp0eT1HoPusZxmrkx'
        },
        enumerable: true,
        writable: false,
        configurable: false,
    })


// 開発（ステージング）環境
} else if ("n-license.firebaseapp.com" === document.domain) {
    // FIREBASE
    Object.defineProperty(exports, "FIREBASE_CONFIG", {
        value:          {
                            apiKey: "AIzaSyAqC7F7EsNb5cfdkXBOiZQRwbTxjTSZdL8",
                            authDomain: "n-license.firebaseapp.com",
                            databaseURL: "https://n-license.firebaseio.com",
                            projectId: "n-license",
                            storageBucket: "n-license.appspot.com",
                            messagingSenderId: "328051668232"
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });

    // TRUST DOCK
    Object.defineProperty(exports, "TRUSTDOCK_CONFIG", {
        value:          {
                            documents_api_url: 'https://api.trustdock.io/v1/documents/',
                            documents_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Project-Key':'DW2ExoaMkrSWkMRMyKHJsbtJ',
                                'HOST':'api.trustdock.io'
                            },
                            review_api_url: 'https://api.trustdock.io/v1/review/',
                            review_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer tksEHm9dCg6bBX8defqcwK4r',
                                'HOST':'api.trustdock.io'
                            },
                            delete_api_url: 'https://api.trustdock.io/v1/review/',
                            delete_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer tksEHm9dCg6bBX8defqcwK4r',
                                'HOST':'api.trustdock.io'
                            },
                            update_api_url: 'https://api.trustdock.io/v1/review/',
                            update_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer tksEHm9dCg6bBX8defqcwK4r',
                                'HOST':'api.trustdock.io'
                            },
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });

    // Scorer Server
    Object.defineProperty(exports, "SCORER_SERVER", {
        value:          {
                            pem: '-----BEGIN PUBLIC KEY-----\n'+
'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAq2fKCUr3q3cM9DlY9+dv\n'+
'EK2defDqzjVj1+r64TTlecbJHl2MHAdOUV0bTWLORviwUao0Zh4zD/Fncb18AvH6\n'+
'u72SAZUiewYJwn8PE+5KLKTgUMf2TlpK7zcTCUvcQkigep5ObRNGyhNnetfT84BV\n'+
'jDUJildGi0HGkrZa2t3lUWfTZky7tvjsSVLOXR+RwTKW2M3kDSPF6Yulnnt7fT43\n'+
'CxV2v1WAGLz4mlerDizbDVmvEoKHUdpklW1SSkXbSeODtYyuqjD8PoHJ3zO+bDa9\n'+
'qLVdNS2p/6jp2M8ozioPYzftmbcy675sx3bASJMKy4CVzIkTGFF4yh3nnu74XS3P\n'+
'+QIDAQAB\n'+
'-----END PUBLIC KEY-----',
                            url: 'https://myrate-scraper-dev.com'
                            //url: 'http://Scorer-1-lb-253858242.ap-northeast-1.elb.amazonaws.com'
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });


    // Auth0
    Object.defineProperty(exports, "AUTH0_CONFIG", {
        value:          { 
                          domain: 'n-village.auth0.com', 
                          clientID: '2bafrx4mAnutwGe9gfUYfC5NS5wYEQ2R', 
                          redirectUri: 'https://n-license.firebaseapp.com/newflow5', 
                          responseType: "code"
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });

    Object.defineProperty(exports, "ENV", {
        value: {
            passwordSecret: 'JYu5JY3Pkjpp'
        },
        enumerable: true,
        writable: false,
        configurable: false,
    })

    // reCAPTCHA
    Object.defineProperty(exports, "RECAPTCHA_CONFIG", {
        value: {
            siteKey: '6Lfvy5sUAAAAAKM1Cj5xMP_5hojq_YhOROVK2-_P'
        },
        enumerable: true,
        writable: false,
        configurable: false,
    })

// ベトナム開発環境
} else if ("n-license-apv.firebaseapp.com" === document.domain) {
    // FIREBASE
    Object.defineProperty(exports, "FIREBASE_CONFIG", {
        value:          {
                           apiKey: "AIzaSyDI-6P2R087Yibop4uDLxg9Unezfv5C_z8",
                            authDomain: "n-license-apv.firebaseapp.com",
                            databaseURL: "https://n-license-apv.firebaseio.com",
                            projectId: "n-license-apv",
                            storageBucket: "n-license-apv.appspot.com",
                            messagingSenderId: "415301814049"
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });

    // TRUST DOCK
    Object.defineProperty(exports, "TRUSTDOCK_CONFIG", {
        value:          {
                            
                            documents_api_url: 'https://api.test.trustdock.io/v1/documents/',
                            documents_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Project-Key':'fzYGYz9bxtdQecgbb3Cz2HjX',
                                'HOST':'api.test.trustdock.io'
                            },
                            review_api_url: 'https://api.test.trustdock.io/v1/review/',
                            review_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer VfToC3QGjZQzLdQftaWw3vyy',
                                'HOST':'api.test.trustdock.io'
                            },
                            delete_api_url: 'https://api.test.trustdock.io/v1/review/',
                            delete_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer VfToC3QGjZQzLdQftaWw3vyy',
                                'HOST':'api.test.trustdock.io'
                            },
                            update_api_url: 'https://api.test.trustdock.io/v1/review/',
                            update_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer VfToC3QGjZQzLdQftaWw3vyy',
                                'HOST':'api.test.trustdock.io'
                            },
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });

    // Scorer Server
    Object.defineProperty(exports, "SCORER_SERVER", {
        value:          {
                            pem: '-----BEGIN PUBLIC KEY-----\n'+
'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAq2fKCUr3q3cM9DlY9+dv\n'+
'EK2defDqzjVj1+r64TTlecbJHl2MHAdOUV0bTWLORviwUao0Zh4zD/Fncb18AvH6\n'+
'u72SAZUiewYJwn8PE+5KLKTgUMf2TlpK7zcTCUvcQkigep5ObRNGyhNnetfT84BV\n'+
'jDUJildGi0HGkrZa2t3lUWfTZky7tvjsSVLOXR+RwTKW2M3kDSPF6Yulnnt7fT43\n'+
'CxV2v1WAGLz4mlerDizbDVmvEoKHUdpklW1SSkXbSeODtYyuqjD8PoHJ3zO+bDa9\n'+
'qLVdNS2p/6jp2M8ozioPYzftmbcy675sx3bASJMKy4CVzIkTGFF4yh3nnu74XS3P\n'+
'+QIDAQAB\n'+
'-----END PUBLIC KEY-----',
                            url: 'https://myrate-scraper-dev.com'
                            //url: 'http://Scorer-1-lb-253858242.ap-northeast-1.elb.amazonaws.com'
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });



    // Auth0
    Object.defineProperty(exports, "AUTH0_CONFIG", {
        value:          { 
                          domain: 'n-village.auth0.com', 
                          clientID: 'kSbkXNxnqNnLE26krEFMDNqUjHnSmGA0', 
                          redirectUri: 'https://n-license-apv.firebaseapp.com/newflow5', 
                          responseType: "code"
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });

    // reCAPTCHA
    Object.defineProperty(exports, "RECAPTCHA_CONFIG", {
        value: {
            siteKey: '6LcDzJsUAAAAAA-luutg-WJJLoaGnpFg4XG6-JMF'
        },
        enumerable: true,
        writable: false,
        configurable: false,
    })

// テスト環境（兼ローカル環境からの接続先）
// document.domain === 'n-lisence-local.firebaseapp.com' || document.domain === 'localhost'
} else {

    // FIREBASE
    Object.defineProperty(exports, "FIREBASE_CONFIG", {
        value:          {
                            apiKey: "AIzaSyB_gUYOZpm5529hRARZ0XA_g8yWfYctJx4",
                            authDomain: "n-lisence-local.firebaseapp.com",
                            databaseURL: "https://n-lisence-local.firebaseio.com",
                            projectId: "n-lisence-local",
                            storageBucket: "n-lisence-local.appspot.com",
                            messagingSenderId: "391223751979"
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });

    // TRUST DOCK
    Object.defineProperty(exports, "TRUSTDOCK_CONFIG", {
        value:          {
                            documents_api_url: 'https://api.test.trustdock.io/v1/documents/',
                            documents_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Project-Key':'fzYGYz9bxtdQecgbb3Cz2HjX',
                                'HOST':'api.test.trustdock.io'
                            },
                            review_api_url: 'https://api.test.trustdock.io/v1/review/',
                            review_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer VfToC3QGjZQzLdQftaWw3vyy',
                                'HOST':'api.test.trustdock.io'
                            },
                            delete_api_url: 'https://api.test.trustdock.io/v1/review/',
                            delete_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer VfToC3QGjZQzLdQftaWw3vyy',
                                'HOST':'api.test.trustdock.io'
                            },
                            update_api_url: 'https://api.test.trustdock.io/v1/review/',
                            update_api_headers: {
                                'Accept':'application/json',
                                'Content-Type':'application/json',
                                'Authorization':'Bearer VfToC3QGjZQzLdQftaWw3vyy',
                                'HOST':'api.test.trustdock.io'
                            },
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });

    // Scorer Server
    Object.defineProperty(exports, "SCORER_SERVER", {
        value:          {
                            pem: '-----BEGIN PUBLIC KEY-----\n'+
'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAq2fKCUr3q3cM9DlY9+dv\n'+
'EK2defDqzjVj1+r64TTlecbJHl2MHAdOUV0bTWLORviwUao0Zh4zD/Fncb18AvH6\n'+
'u72SAZUiewYJwn8PE+5KLKTgUMf2TlpK7zcTCUvcQkigep5ObRNGyhNnetfT84BV\n'+
'jDUJildGi0HGkrZa2t3lUWfTZky7tvjsSVLOXR+RwTKW2M3kDSPF6Yulnnt7fT43\n'+
'CxV2v1WAGLz4mlerDizbDVmvEoKHUdpklW1SSkXbSeODtYyuqjD8PoHJ3zO+bDa9\n'+
'qLVdNS2p/6jp2M8ozioPYzftmbcy675sx3bASJMKy4CVzIkTGFF4yh3nnu74XS3P\n'+
'+QIDAQAB\n'+
'-----END PUBLIC KEY-----',
                            url: 'https://myrate-scraper-dev.com'
                            //url: 'http://Scorer-1-lb-253858242.ap-northeast-1.elb.amazonaws.com'
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });


    const testEnvRedirectUri = 'https://n-lisence-local.firebaseapp.com/newflow5'
    const localEnvRedirectUri = 'http://localhost:3000/newflow5'

    // Auth0
    Object.defineProperty(exports, "AUTH0_CONFIG", {
        value:          { 
                          domain: 'n-village.auth0.com', 
                          clientID: 'PyaI7LTXzDItdfa12P0up6lxQmA4B6R1', 
                          redirectUri: 'localhost' === window.location.hostname ? localEnvRedirectUri : testEnvRedirectUri, 
                          responseType: "code"
                        },
        enumerable:     true,
        writable:       false,
        configurable:   false
    });

    Object.defineProperty(exports, "ENV", {
        value: {
            passwordSecret: 'J2gVW6En6iUh'
        },
        enumerable: true,
        writable: false,
        configurable: false,
    })

    // reCAPTCHA
    Object.defineProperty(exports, "RECAPTCHA_CONFIG", {
        value: {
            siteKey: '6LcTzJsUAAAAAAfkKkJtOWas2aNIuPZ1W31ozhrF'
        },
        enumerable: true,
        writable: false,
        configurable: false,
    })
}



// WEBPACK FOOTER //
// ./src/define.js